const DocumentoIcon = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0378 5.3982H9.7998V0.1656C10.0635 0.297 10.3623 0.5409 10.6962 0.8973L14.3025 4.5027C14.6859 4.8447 14.9316 5.1417 15.0387 5.3982H15.0378ZM15.1998 7.191V16.2C15.1998 17.3997 14.5995 18 13.3998 18H2.6016C1.4001 18 0.799805 17.4006 0.799805 16.2V1.8C0.799805 0.6003 1.4001 0 2.5998 0H7.9998V5.3982C7.9998 6.6204 8.6001 7.2207 9.7998 7.1982C10.8762 7.1775 12.6762 7.1757 15.1998 7.1919V7.191ZM5.2998 11.7H10.6998C11.3001 11.7 11.5998 11.4003 11.5998 10.8C11.5998 10.1997 11.3001 9.9 10.6998 9.9H5.3007C4.7004 9.9 4.4007 10.1997 4.3998 10.8C4.3998 11.4003 4.6995 11.7 5.2998 11.7ZM5.2998 8.1H6.1998C6.8001 8.1 7.0998 7.8003 7.0998 7.2C7.0998 6.5997 6.8001 6.3 6.1998 6.3H5.3007C4.7004 6.3 4.4007 6.5997 4.3998 7.2C4.3998 7.8003 4.6995 8.1 5.2998 8.1ZM5.2998 15.3H10.6998C11.3001 15.3 11.5998 15.0003 11.5998 14.4C11.5998 13.7997 11.3001 13.5 10.6998 13.5H5.2998C4.6995 13.5 4.3998 13.7997 4.3998 14.4C4.3998 15.0003 4.6995 15.3 5.2998 15.3Z"
        fill="white"
      />
    </svg>
  );
};

export default DocumentoIcon;
